import { render } from "./InterventionsPage.vue?vue&type=template&id=4f6c8772&scoped=true"
import script from "./InterventionsPage.vue?vue&type=script&lang=js"
export * from "./InterventionsPage.vue?vue&type=script&lang=js"

import "./InterventionsPage.vue?vue&type=style&index=0&id=4f6c8772&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6c8772"]])

export default __exports__